import { Phone, Mail, Clock, MapPin, MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";
import logoImg from "@/assets/logo.png";

const contactItems = [
  {
    icon: Phone,
    title: "Call Us",
    value: "+254 700 000 000",
    href: "tel:+254700000000",
  },
  {
    icon: MessageCircle,
    title: "WhatsApp",
    value: "Chat with us directly",
    href: "https://wa.me/254700000000?text=Hi%20Precision%20Mobile%20Auto%2C%20I%20need%20a%20service",
    external: true,
  },
  {
    icon: Mail,
    title: "Email",
    value: "info@precisionmobileauto.co.ke",
    href: "mailto:info@precisionmobileauto.co.ke",
  },
];

const Contact = () => (
  <>
    <PageHeader title="Contact Us" subtitle="Get in touch — we'll come to you" breadcrumb="Contact" />

    <section className="section-padding bg-background relative overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 bg-primary/3 rounded-full blur-[120px]" />
      
      <div className="container mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-14 max-w-5xl mx-auto">
          {/* Contact Info */}
          <div>
            <h2 className="font-heading text-xl sm:text-2xl uppercase text-foreground mb-2">Get in Touch</h2>
            <div className="premium-divider max-w-[60px] mb-8" />
            
            <div className="space-y-4">
              {contactItems.map((item) => (
                <a
                  key={item.title}
                  href={item.href}
                  {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  className="flex items-start gap-4 group p-3 -mx-3 rounded-xl hover:bg-primary/5 transition-all duration-300"
                >
                  <div className="p-2.5 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 group-hover:shadow-premium transition-all duration-500 shrink-0">
                    <item.icon className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <p className="font-heading text-sm uppercase tracking-wider text-foreground">{item.title}</p>
                    <p className="text-muted-foreground text-sm">{item.value}</p>
                  </div>
                </a>
              ))}

              <div className="flex items-start gap-4 p-3 -mx-3">
                <div className="p-2.5 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 shrink-0">
                  <MapPin className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="font-heading text-sm uppercase tracking-wider text-foreground">Service Area</p>
                  <p className="text-muted-foreground text-sm">Thika Town, Section 9, Landless, Nanyuki Road, Juja</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-3 -mx-3">
                <div className="p-2.5 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 shrink-0">
                  <Clock className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="font-heading text-sm uppercase tracking-wider text-foreground">Hours</p>
                  <p className="text-muted-foreground text-sm">Mon – Sat: 7:00 AM – 7:00 PM</p>
                  <p className="text-muted-foreground text-sm">Sunday: Emergency calls only</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Action Card */}
          <div className="bg-charcoal-gradient rounded-xl p-6 sm:p-8 lg:p-10 flex flex-col justify-center relative overflow-hidden noise-overlay shadow-elevated">
            <div className="absolute top-0 right-0 w-48 h-48 bg-primary/5 rounded-full blur-[80px]" />
            <div className="relative z-10">
              <img src={logoImg} alt="Precision Mobile Auto" className="h-14 sm:h-16 w-auto mb-6 drop-shadow-lg" />
              <h2 className="font-heading text-xl sm:text-2xl uppercase text-secondary-foreground mb-3">
                Need a <span className="text-gradient">Quick Fix?</span>
              </h2>
              <p className="text-silver/70 text-sm mb-8 leading-relaxed">
                The fastest way to reach us is via WhatsApp. Describe your car problem, share your location, and we'll give you an instant quote.
              </p>
              <div className="space-y-3">
                <Button variant="whatsapp" size="xl" className="w-full text-sm sm:text-base" asChild>
                  <a href="https://wa.me/254700000000?text=Hi%20Precision%20Mobile%20Auto%2C%20I%20need%20a%20service" target="_blank" rel="noopener noreferrer">
                    <MessageCircle className="h-5 w-5" />
                    Chat on WhatsApp
                  </a>
                </Button>
                <Button variant="hero" size="xl" className="w-full text-sm sm:text-base" asChild>
                  <a href="tel:+254700000000">
                    <Phone className="h-5 w-5" />
                    Call Now
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Contact;
